
import { createNamespacedHelpers } from 'vuex'
const { mapState } = createNamespacedHelpers('education')

export default {
  name: 'StreamListTheList',

  props: {
    availableStreamLists: {
      type: Array,
      default: () => [],
      required: true
    },

    attendeeId: {
      type: Number,
      default: 0,
      required: true
    },

    currentStreamId: {
      type: Number,
      default: 0,
      required: false
    },

    refreshTab: {
      type: Function,
      required: true
    },

    isChange: {
      type: Boolean,
      default: false,
      required: false
    }
  },

  data() {
    return {
      i18n: 'pages.education.courses-list.gu-stream-lists',
      isLoading: false
    }
  },

  computed: {
    ...mapState(['streamLists']),

    isStreamList() {
      return (
        this.availableStreamLists.length && Object.keys(this.streamLists).length
      )
    },

    list() {
      if (!this.isStreamList) {
        return []
      }

      return this.availableStreamLists.map(id => this.streamLists[id])
    }
  },

  methods: {
    transformStartDate(date) {
      if (!date) return '-'

      const startDate = this.$moment(date, 'DD MMMM', 'ru')
      const today = this.$moment()

      return startDate.isSame(today, 'day')
        ? this.$t(`${this.i18n}.today`)
        : startDate.isSame(today.add(1, 'day'), 'day')
        ? this.$t(`${this.i18n}.tomorrow`)
        : date
    },

    async selectStream(id) {
      this.isLoading = true

      const payload = {
        product_attendee_id: this.attendeeId,
        old_id: this.currentStreamId,
        id
      }

      await this.$store.dispatch(
        `education/${this.isChange ? 'changeStream' : 'selectStream'}`,
        payload
      )
      await this.$store.dispatch('education/fetchBlockData', this.attendeeId)
      this.refreshTab()
      await this.$store.dispatch(
        'education/fetchBlockProgressItems',
        this.attendeeId
      )

      this.isLoading = false

      if (this.isChange) {
        document.body.style.overflow = ''
        document.body.classList.remove('modal-open')
        this.$emit('close')
      }
    }
  }
}
